export default __webpack_public_path__ + "static/media/image07.eb76d181.jpg";